import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule } from './dashboard.routing.module';
import { MaterialModule } from '../shared/material/material.module';
import { SharedModule } from '../shared/shared.module';
import { WelcomePanelComponent } from './welcome-panel/welcome-panel.component';
import { HealthPanelComponent } from './health-panel/health-panel.component';
import { WellnessPanelComponent } from './wellness-panel/wellness-panel.component';
import { FooterComponent } from './footer/footer.component';
import { FeedsPanelComponent } from './feeds-panel/feeds-panel.component';
import { ModalService } from 'src/app/services/core/modal.service';
import { ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AppointmentsService } from '../../services/scheduling/appointment/appointments.service';

@NgModule({
	imports: [CommonModule, DashboardRoutingModule, SharedModule, MaterialModule, ReactiveFormsModule, PdfViewerModule],
	declarations: [
		DashboardComponent,
		WelcomePanelComponent,
		HealthPanelComponent,
		WellnessPanelComponent,
		FooterComponent,
		FeedsPanelComponent,
	],
	providers: [ModalService, { provide: AppointmentsService, useClass: AppointmentsService }],
})
export class DashboardModule {}
